import * as React from "react"

export const ThemesIcon = ({
  width = 40,
  height = 40,
  ...rest
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...rest}
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width={width} height={height} rx="8" fill="#F9F2FF" />
    <path
      d="M21.5 16C21.7761 16 22 15.7761 22 15.5C22 15.2239 21.7761 15 21.5 15C21.2239 15 21 15.2239 21 15.5C21 15.7761 21.2239 16 21.5 16Z"
      stroke="#7026B9"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.5 20C25.7761 20 26 19.7761 26 19.5C26 19.2239 25.7761 19 25.5 19C25.2239 19 25 19.2239 25 19.5C25 19.7761 25.2239 20 25.5 20Z"
      stroke="#7026B9"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5 17C16.7761 17 17 16.7761 17 16.5C17 16.2239 16.7761 16 16.5 16C16.2239 16 16 16.2239 16 16.5C16 16.7761 16.2239 17 16.5 17Z"
      stroke="#7026B9"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5 22C14.7761 22 15 21.7761 15 21.5C15 21.2239 14.7761 21 14.5 21C14.2239 21 14 21.2239 14 21.5C14 21.7761 14.2239 22 14.5 22Z"
      stroke="#7026B9"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 11C14.5 11 10 15.5 10 21C10 26.5 14.5 31 20 31C20.926 31 21.648 30.254 21.648 29.312C21.648 28.875 21.468 28.477 21.211 28.187C20.921 27.898 20.773 27.535 20.773 27.062C20.7692 26.8419 20.8098 26.6233 20.8922 26.4192C20.9747 26.2151 21.0975 26.0298 21.2531 25.8741C21.4088 25.7185 21.5941 25.5957 21.7982 25.5132C22.0023 25.4308 22.2209 25.3902 22.441 25.394H24.437C27.488 25.394 29.992 22.891 29.992 19.84C29.965 15.012 25.461 11 20 11Z"
      stroke="#7026B9"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
